<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :headers="headers"
                        :items="assessments"
                        sort-by="Date"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Assessments"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Assessments</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <action-control-menu
                                    ref="actions"
                                    :actions="['Print', 'Download']"
                                    :navigateTo="navigateTo"
                                    :payload="payload"
                                    btnTitle="New"
                                />
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2 hidden-sm-and-down"
                                @click="viewAssessment(item)"
                            >
                                mdi-eye
                            </v-icon>

                            <v-btn
                                outlined
                                medium
                                class="mr-4 hidden-md-and-up"
                                color="light-blue darken-4"
                                @click="viewAssessment(item)"
                            >
                                view
                            </v-btn>

                            <v-icon
                                small
                                class="hidden-sm-and-down"
                                @click="deleteAssessment(item)"
                                v-if="!hide"
                            >
                                mdi-delete
                            </v-icon>

                            <v-btn
                                medium
                                outlined
                                class="hidden md-and-up red--text"
                                @click="deleteAssessment(item)"
                                v-if="!hide"
                            >
                                delete
                            </v-btn>
                        </template>
                        <template v-slot:no-data>
                            <v-btn
                                color="#2b3990"
                                class="white--text"
                                @click="getAssessments()"
                            >Reset
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>

        <OptionMenu :onAction="handleActions"/>

    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import ActionControlMenu from "@/components/ActionControlMenu";
import { mapGetters } from "vuex";

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ActionControlMenu
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Assessment Date",
                    align: "start",
                    sortable: false,
                    value: "Date",
                },
                {text: "Interviewer", value: "Interviewer"},
                {text: "History", value: "History"},
                {text: "Signature", value: "InterviewerSig"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            dialog: false,
            editAssessment: false,
            newAssessment: false,
            msg: false,
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            search: "",
            text: "",
            assessments: [],
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem("userID"),
            tempData: [],
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            hide: true,
            payload: {}
        };
    },

    computed: {
        ...mapGetters({
            client: "clients/clientData",
        }),

        formTitle() {
            return this.editedIndex != 1 ? "New Item" : "Edit Item";
        },

        navigateTo() {
        return {
                path: `/assessments/${this.clientID}/new`,
                query: {newAssessment: true}
            };
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.getAssessments();
    },

    mounted() {
        this.getAssessments();
        document.addEventListener("keydown", this.handleKeyDown);
    },

    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyDown);
    },

    methods: {

        initialize() {
            this.assessments = [];
        },

        initializePayload() {
            this.payload = {
                query: {
                name: this.client?.Name,
                clientId: this.client?._id,
                generateFile: true,
                page: this.currentPage,
                limit: this.itemsPerPage,
                keyword: this.searchKeyword,
                searchFields: this.headers
                    .filter((h) => h.value !== "actions")
                    .map((h) => h.value),
                },
                endpoints: `assessments/client/${this.client?._id}`,
                dynamic: true,
                fileName: `${this.client?.Name}-assessments.pdf`,
            };
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewAssessment(item) {
            this.$router.push({
                path: `/assessments/${this.clientID}/update/${item._id}`,
                query: {newAssessment: false}
            })
        },

        showAdd() {
            this.$router.push({
                path: `/assessments/${this.clientID}/new`,
                query: {newAssessment: true}
            })
        },

        deleteAssessment(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this assessment?") &&
            this.assessmentDelete(id);
            this.isLoading = true;
        },

        assessmentDelete(id) {
            axios.delete(`${url}/assessments/${id}`).then((response) => {
                this.getAssessments();
                if (response.status == 400) {
                    response.json().then(function (data) {
                        return data.msg;
                    });
                }
                this.msg = true;
                this.text = "The assessment record has been deleted successfully.";
            });
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        updateAssessment() {
            var req_body = {
                Date: this.newDate,
                Interviewer: this.newInterviewer,
                History: this.newHistory,
                MedicalSupport: this.newMedicalSupport,
                Physician: this.newPhysician,
                PreviousPhysical: this.newPreviousPhysical,
                PhysicalNotes: this.newPhysicalNotes,
                Dentist: this.newDentist,
                PreviousDental: this.newPreviousDental,
                DentalNotes: this.newDentalNotes,
                Psychiatrist: this.newPsychiatrist,
                PsychEval: this.newPsychEval,
                PsychNotes: this.newPsychNotes,
                Neurologist: this.newNeurologist,
                PreviousNeuro: this.newPreviousNeuro,
                NeuroNotes: this.newNeuroNotes,
                Hospital: this.newHospital,
                Pharmacy: this.newPharmacy,
                NewProviders: this.newNewProviders,
                Allergies: this.newAllergies,
                DrugAllergies: this.newDrugAllergies,
                Immunizations: this.newImmunizations,
                DietaryNeeds: this.newDietaryNeeds,
                Elimination: this.newElimination,
                Urination: this.newUrination,
                AdditionalNotes: this.newAdditionalNotes,
                EnergyLevel: this.newEnergyLevel,
                SleepChanges: this.newSleepChanges,
                SleepTime: this.newSleepTime,
                Awakenings: this.newAwakenings,
                SleepHours: this.newSleepHours,
                SleepType: this.newSleepType,
                Awareness: this.newAwareness,
                Appearance: this.newAppearance,
                Behavior: this.newBehavior,
                Affect: this.newAffect,
                Summary: this.newSummary,
                InterviewerSig: this.newInterviewerSig,
                Signed: this.signed,
            };
            axios
                .put(`${url}/assessments/${this.assessmentID}`, req_body)
                .then((response) => {
                    this.getAssessments();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    }
                    this.newDate = "";
                    this.newInterviewer = "";
                    this.newHistory = "";
                    this.newMedicalSupport = "";
                    this.newPhysician = "";
                    this.newPreviousPhysical = "";
                    this.newPhysicalNotes = "";
                    this.newDentist = "";
                    this.newPreviousDental = "";
                    this.newDentalNotes = "";
                    this.newPsychiatrist = "";
                    this.newPsychEval = "";
                    this.newPsychNotes = "";
                    this.newNeurologist = "";
                    this.newPreviousNeuro = "";
                    this.newNeuroNotes = "";
                    this.newHospital = "";
                    this.newPharmacy = "";
                    this.newNewProviders = "";
                    this.newAllergies = "";
                    this.newDrugAllergies = "";
                    this.newImmunizations = "";
                    this.newDietaryNeeds = "";
                    this.newElimination = "";
                    this.newUrination = "";
                    this.newAdditionalNotes = "";
                    this.newEnergyLevel = "";
                    this.newSleepChanges = "";
                    this.newSleepTime = "";
                    this.newAwakenings = "";
                    this.newSleepHours = "";
                    this.newSleepType = "";
                    this.newAwareness = "";
                    this.newAppearance = "";
                    this.newBehavior = "";
                    this.newAffect = "";
                    this.newSummary = "";
                    this.newInterviewerSig = "";
                    this.msg = true;
                    this.text = "The assessment record has been updated successfully.";
                });
            this.isLoading = true;
            this.close();
        },
        getAssessments: function () {
            this.isLoading = true;
            this.assessments = [];
            axios
                .get(`${url}/assessments/client/${this.clientID}`)
                .then((res) => {
                    this.assessments = res.data.results;
                    this.getUsers();
                })
                .finally(() => (this.isLoading = false, this.initializePayload()));
        },

        getUsers: function () {
            axios.get(`${url}/users`).then(async (res) => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID == this.users[i]._id) {
                        this.staff = this.users[i].Name;
                    }
                }
            });
        },

        addSignature: function () {
            if (!this.signed) {
                return (this.newInterviewerSig = "");
            }
            this.newInterviewerSig = this.staff + " - " + new Date();
            this.signed = true;
        },

        addAssessment: function () {
            var req_body = {
                Date: this.newDate,
                Interviewer: this.newInterviewer,
                History: this.newHistory,
                MedicalSupport: this.newMedicalSupport,
                Physician: this.newPhysician,
                PreviousPhysical: this.newPreviousPhysical,
                PhysicalNotes: this.newPhysicalNotes,
                Dentist: this.newDentist,
                DentalNotes: this.newDentalNotes,
                PreviousDental: this.newPreviousDental,
                Psychiatrist: this.newPsychiatrist,
                PsychEval: this.newPsychEval,
                PsychNotes: this.newPsychNotes,
                Neurologist: this.newNeurologist,
                PreviousNeuro: this.newPreviousNeuro,
                NeuroNotes: this.newNeuroNotes,
                Hospital: this.newHospital,
                Pharmacy: this.newPharmacy,
                NewProviders: this.newNewProviders,
                Allergies: this.newAllergies,
                DrugAllergies: this.newDrugAllergies,
                Immunizations: this.newImmunizations,
                DietaryNeeds: this.newDietaryNeeds,
                Elimination: this.newElimination,
                Urination: this.newUrination,
                AdditionalNotes: this.newAdditionalNotes,
                EnergyLevel: this.newEnergyLevel,
                SleepChanges: this.newSleepChanges,
                SleepTime: this.newSleepTime,
                Awakenings: this.newAwakenings,
                SleepHours: this.newSleepHours,
                SleepType: this.newSleepType,
                Awareness: this.newAwareness,
                Appearance: this.newAppearance,
                Behavior: this.newBehavior,
                Affect: this.newAffect,
                Summary: this.newSummary,
                InterviewerSig: this.newInterviewerSig,
                ClientID: this.clientID,
                Signed: this.signed,
            };

            axios.post(`${url}/assessments`, req_body).then((res) => {
                this.getAssessments();
                if (res.status == 400) {
                    res.json().then(function (data) {
                        this.text = data.msg;
                    });
                }
                this.newDate = "";
                this.newInterviewer = "";
                this.newHistory = "";
                this.newMedicalSupport = "";
                this.newPhysician = "";
                this.newPreviousPhysical = "";
                this.newPhysicalNotes = "";
                this.newDentist = "";
                this.newPreviousDental = "";
                this.newDentalNotes = "";
                this.newPsychiatrist = "";
                this.newPsychEval = "";
                this.newPsychNotes = "";
                this.newNeurologist = "";
                this.newPreviousNeuro = "";
                this.newNeuroNotes = "";
                this.newHospital = "";
                this.newPharmacy = "";
                this.newNewProviders = "";
                this.newAllergies = "";
                this.newDrugAllergies = "";
                this.newImmunizations = "";
                this.newDietaryNeeds = "";
                this.newElimination = "";
                this.newUrination = "";
                this.newAdditionalNotes = "";
                this.newEnergyLevel = "";
                this.newSleepChanges = "";
                this.newSleepTime = "";
                this.newAwakenings = "";
                this.newSleepHours = "";
                this.newSleepType = "";
                this.newAwareness = "";
                this.newAppearance = "";
                this.newBehavior = "";
                this.newAffect = "";
                this.newSumary = "";
                this.newInterviewerSig = "";
                this.msg = true;
                this.text = "The new assessment has been added successfully.";
            });
            this.isLoading = true;
            this.close();
        },

        handleActions(action) {
            if (this.$refs.actions) {
                this.$refs.actions.onSelectAction(action);
            } else {
                console.error("reference not found");
            }
        },
    },
};
</script>
<style>
#printTable{
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}


@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
  
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;
  
    }
  
    @page { margin: 0; }
    body { margin: 1.6cm; }
  }
</style>
